
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="site-footer bg-white py-16">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
          {/* Brand Section */}
          <div className="lg:col-span-4">
            <div className="mb-6">
              <span className="text-lg font-bold">Navamuel - Fabricantes de Muebles de Baño a medida</span>
            </div>
            <div className="mb-8">
              <p className="text-gray-600 text-sm leading-relaxed">
                Somos una fábrica de muebles de baño de calidad premium ubicada en Pulgar, Toledo. 
                Especialistas en maderas naturales, diseño vanguardista y materiales innovadores. 
                Treinta años de experiencia creando baños excepcionales.
              </p>
            </div>
            <div className="mb-4">
              <p className="text-xs text-gray-500 mb-2 font-semibold">Especialidades:</p>
              <div className="flex flex-wrap gap-2">
                <span className="text-xs bg-gray-100 px-2 py-1 rounded">Maderas Naturales</span>
                <span className="text-xs bg-gray-100 px-2 py-1 rounded">Diseño Premium</span>
                <span className="text-xs bg-gray-100 px-2 py-1 rounded">Porcelánicos</span>
                <span className="text-xs bg-gray-100 px-2 py-1 rounded">Piedras Compactas</span>
              </div>
            </div>
          </div>

          {/* Newsletter Section */}
            <div className="lg:col-span-5 lg:order-2">
              <div className="mb-6">
                <h3 className="text-lg font-medium mb-4">Ubicación y Contacto</h3>
                <div className="w-full h-64 rounded overflow-hidden border border-gray-300 mb-4">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3048.123456789!2d-4.2876543!3d39.8234567!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zUG9sw61nb25vIEluZHVzdHJpYWwsIFB1bGdhciwgVG9sZWRvLCBFc3Bhw7Fh!5e0!3m2!1ses!2ses!4v1642000000000!5m2!1ses!2ses"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen={true}
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Mapa de ubicación Muebles Navamuel - Polígono Industrial, Pulgar, Toledo"
                ></iframe>
                </div>
                <div className="text-sm text-gray-600 mb-3">
                  <p className="font-semibold mb-2">📍 Fábrica de Muebles de Baño en Toledo</p>
                  <p className="mb-1"><strong>Dirección:</strong> Polígono Industrial, C/ Molinillo 15-16</p>
                  <p className="mb-1"><strong>Localidad:</strong> 45125 Pulgar (Toledo) España</p>
                  <p className="mb-1"><strong>Teléfono:</strong> <a href="tel:+34925292003" className="hover:text-black">+34 925 29 20 03</a></p>
                  <p className="mb-3"><strong>Horario:</strong> L-J: 9:00-14:00 y 16:30-19:30 | V: 9:00-14:00</p>
                </div>
                <Link to="/contacto" className="text-sm text-blue-600 hover:text-blue-800 font-semibold">
                  📧 Contactar para asesoramiento →
                </Link>
              </div>
            </div>

          {/* Navigation Menus */}
          <div className="lg:col-span-3 lg:order-1">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              <div>
                <h3 className="text-lg font-medium mb-4">Muebles de Baño</h3>
                <ul className="space-y-2">
                  <li><Link to="/maderas" className="text-gray-600 hover:text-black">Maderas Naturales para Baño</Link></li>
                  <li><Link to="/materiales" className="text-gray-600 hover:text-black">Materiales de Baño Premium</Link></li>
                  <li><Link to="/muebles-de-bano" className="text-gray-600 hover:text-black">Ambientes y Diseño</Link></li>
                  <li><Link to="/proyectos" className="text-gray-600 hover:text-black">Proyectos Realizados</Link></li>
                </ul>
              </div>
              <div>
                <h3 className="text-lg font-medium mb-4">Empresa</h3>
                <ul className="space-y-2">
                  <li><Link to="/nosotros" className="text-gray-600 hover:text-black">Sobre Navamuel Toledo</Link></li>
                  <li><Link to="/contacto" className="text-gray-600 hover:text-black">Contactar - Asesoramiento</Link></li>
                  <li><Link to="/descargas" className="text-gray-600 hover:text-black">Catálogos y Descargas</Link></li>
                  <li><Link to="/aviso-legal" className="text-gray-600 hover:text-black">Aviso Legal</Link></li>
                </ul>
              </div>
            </div>
            <div className="mt-8">
              <h3 className="text-lg font-medium mb-4">Síguenos</h3>
              <ul className="space-y-2">
                <li>
                  <a 
                    href="https://www.instagram.com/navamuel.banos" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="text-pink-600 hover:text-pink-700 inline-flex items-center gap-2 transition-colors"
                    title="Síguenos en Instagram - @navamuel.banos"
                  >
                    <i className="ri-instagram-line text-xl"></i>
                    <span>@navamuel.banos</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Copyright Section */}
        <div className="lg:col-span-12 mt-16 pt-8 border-t border-gray-200">
          <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center">
            <div className="mb-4 lg:mb-0">
              <p className="text-sm text-gray-600 mb-2">©2026 Navamuel Baños - Fábrica de Muebles de Baño en Toledo</p>
              <p className="text-xs text-gray-500">
                Polígono Industrial, C/ Molinillo 15-16, 45125 Pulgar, Toledo | 
                <a href="tel:+34925292003" className="hover:text-black ml-1">+34 925 29 20 03</a>
              </p>
            </div>
            <div className="flex items-center space-x-4">
              <Link to="/aviso-legal" className="text-sm text-gray-600 hover:text-black">Privacidad</Link>
              <span className="text-gray-300">|</span>
              <Link to="/aviso-legal" className="text-sm text-gray-600 hover:text-black">Aviso Legal</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
